import { FC, Fragment } from "preact/compat";
import type { DropdownProps } from "./interfaces";
import ArrowIcon from "@material-design-icons/svg/outlined/keyboard_arrow_down.svg";
import { Listbox, Transition } from "@headlessui/react";
import cn from "classnames";

const Dropdown: FC<DropdownProps> = ({
    value,
    choices = [],
    label,
    onChange,
    className,
    buttonClassName = "border border-gray-300 rounded-3xl transition duration-100 hover:border-sky-500 shadow-inner",
}) => (
    <Listbox value={value} onChange={onChange}>
        <div className={cn("relative", className)}>
            <Listbox.Button
                className={cn(
                    buttonClassName,
                    "flex items-center justify-between w-full px-4 bg-white focus:outline-sky-500 select-none py-1"
                )}
            >
                {({ open }: { open: boolean }) => (
                    <>
                        <span className="block truncate">
                            {value?.name || label}
                        </span>
                        <span>
                            <ArrowIcon
                                width="12"
                                className={cn(
                                    "transition duration-100",
                                    open && "rotate-180"
                                )}
                            />
                        </span>
                    </>
                )}
            </Listbox.Button>
            <Transition
                as={Fragment}
                enterFrom="opacity-0 translate-y-2"
                enter="transition easy-in-out duration-200"
                leave="transition easy-in duration-100"
                leaveTo="opacity-0 translate-y-2"
            >
                <Listbox.Options className="absolute z-30 w-full mt-1 bg-white border border-t-0 border-gray-300 shadow-lg rounded-3xl overflow-y-overlay max-h-60 focus:outline-sky-500">
                    {choices.map((choice) => (
                        <Listbox.Option
                            key={choice.id}
                            className={({ active }: { active: boolean }) =>
                                cn(
                                    "px-4 py-1 border-t border-gray-200 cursor-default last:rounded-b-3xl first:rounded-t-3xl",
                                    active && "bg-sky-700 text-white"
                                )
                            }
                            value={choice}
                        >
                            <span>{choice.name}</span>
                        </Listbox.Option>
                    ))}
                </Listbox.Options>
            </Transition>
        </div>
    </Listbox>
);

export default Dropdown;
